export default __webpack_public_path__ + "static/hero-9b9a684debff695afd0bbac580faa373.png";